<template>
	<div>
		<!-- 详情 -->
		<el-dialog title="查看触发器" :visible.sync="dialogDetailVisible" width="600px" :close-on-click-modal="false" :before-close="handleClose">
			<el-row>
				<el-descriptions class="margin-top" :column="1" :labelStyle="label_style">
					<el-descriptions-item label="触发器名称">
						{{addOrUpdateForm.title}}
					</el-descriptions-item>
					<el-descriptions-item label="触发器类型">
						{{addOrUpdateForm.type | formatType}}
					</el-descriptions-item>
					<el-descriptions-item label="模版和变量">
						{{addOrUpdateForm.templateTitle}}-{{addOrUpdateForm.variableTitle}}
					</el-descriptions-item>
					<el-descriptions-item label="触发条件">
						{{addOrUpdateForm | formatTriggerCondition}}
					</el-descriptions-item>
					<el-descriptions-item label="报警">
						<el-switch v-model="addOrUpdateForm.openAlarm" :disabled="true"></el-switch>
					</el-descriptions-item>
					<el-descriptions-item label="报警内容">
						<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.alarmMessage"></el-input>
					</el-descriptions-item>
				</el-descriptions>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="handleClose">取 消</el-button>
			</div>
		</el-dialog>

	</div>
</template>
<script>
	export default {
		name: 'templateTriggerDetail',
		props: ['dialogDetailVisible', 'addOrUpdateForm'],
		data() {
			return {
				label_style: {
					// 解决不对齐的问题
					'width': "100px", // 给标签设置足够的宽度之后让标签往右偏移
					'float': 'right',
					'text-align': 'right',
					'display': 'block',
					'word-break': 'break-all'
				},
			};
		},
		filters: {
			formatTriggerCondition(data) {
				if (data) {
					var condition = data.triggerCondition
					if (data.triggerCondition) {
						if (condition.includes('A')) {
							condition = condition.replace('A', data.a)
						}
						if (condition.includes('B')) {
							condition = condition.replace('B', data.b)
						}
						return condition
					}
				}
			},
			formatType(type) {
				if (type == "device") {
					return '设备'
				}
			}
		},
		methods: {
			handleClose() {
				this.$emit("update:dialogDetailVisible", false);
			}
		},
		mounted: function() {

		}

	}
</script>


// WEBPACK FOOTER //
// src/components/layout/devices/templateTriggerDetail.vue